module.exports = __webpack_public_path__ + "dfb5fe1230ae691ff291f27cad39739f.png";